import { OfferReview } from '../../../models/mailOfferReview';

/**
 * Validates an offer against the backend schema
 * Maps form field names to schema requirements and validates
 * TODO: include real backend schema instead of hardcoding validation here
 * @param offer The offer object to validate
 * @param t Translation function
 * @returns Array of validation error messages
 */
export const validateOfferAgainstSchema = (offer: OfferReview, t: (key: string) => string): string[] => {
  const errors: string[] = [];

  // Validate contactPerson object has email
  if (!offer?.contactPerson?.email) {
    errors.push(t('Contact Email is required'));
  }

  // Validate loadingPlaces array has exactly 2 items
  if (!offer?.loadingPlaces || !Array.isArray(offer.loadingPlaces) || offer.loadingPlaces.length < 2) {
    errors.push(t('Both loading and unloading places are required'));
  } else {
    const loadingPlace = offer.loadingPlaces[0];
    const unloadingPlace = offer.loadingPlaces[1];

    // Validate loading place (maps to earliestStart/latestStart)
    if (!loadingPlace?.address?.city) {
      errors.push(t('Loading Place City is required'));
    }
    if (!loadingPlace?.address?.country) {
      errors.push(t('Loading Place Country is required'));
    }
    if (!loadingPlace?.address?.postalCode) {
      errors.push(t('Loading Place Postal Code is required'));
    }
    if (!loadingPlace?.earliestLoadingDate) {
      errors.push(t('Earliest Start date is required'));
    }
    if (!loadingPlace?.latestLoadingDate) {
      errors.push(t('Latest Start date is required'));
    }

    // Validate unloading place (maps to earliestEnd/latestEnd)
    if (!unloadingPlace?.address?.city) {
      errors.push(t('Unloading Place City is required'));
    }
    if (!unloadingPlace?.address?.country) {
      errors.push(t('Unloading Place Country is required'));
    }
    if (!unloadingPlace?.address?.postalCode) {
      errors.push(t('Unloading Place Postal Code is required'));
    }
    if (!unloadingPlace?.earliestLoadingDate) {
      errors.push(t('Earliest End date is required'));
    }
    if (!unloadingPlace?.latestLoadingDate) {
      errors.push(t('Latest End date is required'));
    }
  }

  return errors;
};
